import { render, staticRenderFns } from "./landlord-bill.vue?vue&type=template&id=3041ffe6&scoped=true&"
import script from "./landlord-bill.vue?vue&type=script&lang=js&"
export * from "./landlord-bill.vue?vue&type=script&lang=js&"
import style0 from "./landlord-bill.vue?vue&type=style&index=0&id=3041ffe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041ffe6",
  null
  
)

export default component.exports